module.exports = __webpack_public_path__ + "img/wonderr64_ua.2ad47c18.webp";